import React from 'react'
import cx from 'classnames'

export interface ILoaderIndicator extends React.HTMLAttributes<HTMLDivElement> {
  className?: string
}

const LoaderIndicator = function ({ className, ...props }: ILoaderIndicator) {
  return (
    <div className={cx(className, 'ocla-loader-indicator')} {...props}>
      <div className='lds-ring'>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default React.memo(LoaderIndicator)
